<template>
  <div id="add-new-order-modal">
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="editCashBackModal"
        persistent
        max-width="450px"
      >
        <v-card>
          <form
            action=""
            @submit.prevent="submitForm()"
          >
            <v-card-title>
              <v-flex
                xs11
                sm11
                md11
              ><span class="headline">{{ $t('cashBack.editTitle') }}</span></v-flex>
              <v-flex
                xs1
                sm1
                md1
              >
                <v-btn
                  flat
                  @click="closeEditCashBackModal(), $validator.reset()"
                  class="close"
                ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                type="success"
                :value="checkAlert"
              >
                {{ $t('cashBack.updatedSuccessfully') }}
              </v-alert>
              <v-alert
                type="error"
                :value="backendError"
              >
                {{ $t('shippingPrices.pleaseUpdateAnythingError') }}
              </v-alert>
              <v-layout wrap>
                <v-flex xs12>
                  <v-select
                    :items="banks"
                    v-model="editCashBackData.bank_id_fk"
                    :error-messages="errors.collect('bank')"
                    data-vv-name="bank"
                    :label="$t('columns.bank') + '*'"
                    v-validate="'required'"
                    single-line
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    :label="$t('columns.amount') + '*'"
                    v-model.number="editCashBackData.amount"
                    :error-messages="errors.collect('amount')"
                    v-validate="'required|decimal:2'"
                    data-vv-name="amount"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    :label="$t('columns.note')"
                    v-model="editCashBackData.note"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeEditCashBackModal(), $validator.reset()"
                outline
                color="normal"
              >{{ $t('common.cancel') }}</v-btn>
              <v-btn
                type="submit"
                style="height:auto" class="rtl-mr-5pct"
                outline
                color="success"
              >{{ $t('common.update') }}</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'editCashBackModal',
    'closeEditCashBackModal',
    'checkAlert',
    'editCashBackData',
    'editCashBack',
    'backendError',
    'banks'
  ],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.editCashBack()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user/user_credit/editCashBack.vue